import { useAppSelector } from '@features';
import { ScrollArea } from '@repo/shadcn';

import { IwForm } from '@components/form';

import { SectionContainer } from '@/components/shared';
import { HeaderBreadcrumb } from '@/components/ui';
import { Route } from '@/constants';
import {
    CreateExpiredStockAdjustmentProvider,
    useCreateExpiredStockAdjustmentContext,
} from '@/modules/adjustment/expired-stock-adjustment/create/context';
import { CreateExpiredStockAdjustmentSchema } from '@/modules/adjustment/expired-stock-adjustment/create/schema';
import { SupplierSelector } from '@/modules/purchase/pre-purchase/create-pre-purchase/supplier-selector.component';

import { ExpiryRestockItemList } from './item-list.component';
import { OverviewAndSubmit } from './overview-and-submit.component';

export const CreateExpiredStockAdjustmentComponent = () => {
    const { handleSubmit } = useCreateExpiredStockAdjustmentContext();

    const items = useAppSelector((state) => state.expiryAdjustment.items) ?? [];

    return (
        <SectionContainer>
            <IwForm
                schema={CreateExpiredStockAdjustmentSchema}
                initialValues={{
                    // @ts-expect-error react-hook-form issue
                    items,
                }}
                onSubmit={handleSubmit as any}
            >
                <HeaderBreadcrumb
                    items={[
                        {
                            label: 'Expiry Adjustments',
                            href: Route.ADJUSTMENT_EXPIRED_PRODUCTS,
                        },
                        {
                            label: 'Create',
                        },
                    ]}
                />
                <div className={'relative grid grid-cols-[2fr_1fr] gap-2'}>
                    <ScrollArea className={'h-[calc(100vh_-_120px)] space-y-2'}>
                        <ExpiryRestockItemList />
                    </ScrollArea>

                    <ScrollArea
                        className={'h-[calc(100vh_-_120px)] gap-2 space-y-2'}
                    >
                        <SupplierSelector />
                        {/*<BrandSelector />*/}
                        {/*<ProductSelector />*/}
                    </ScrollArea>

                    <OverviewAndSubmit />
                </div>
            </IwForm>
        </SectionContainer>
    );
};

export const CreateExpiredStockAdjustment = () => {
    return (
        <CreateExpiredStockAdjustmentProvider>
            <CreateExpiredStockAdjustmentComponent />
        </CreateExpiredStockAdjustmentProvider>
    );
};

CreateExpiredStockAdjustment.displayName = 'CreateExpiredStockAdjustment';
